module.exports = __webpack_public_path__ + "static/media/Large-01MA030K20DTS_CMJN___.8f9d4856.png";